/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function MoveCarDtoFromJSON(json) {
    return MoveCarDtoFromJSONTyped(json, false);
}
export function MoveCarDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'oldGarageId': !exists(json, 'oldGarageId') ? undefined : json['oldGarageId'],
        'newGarageId': !exists(json, 'newGarageId') ? undefined : json['newGarageId'],
        'garageSpotId': !exists(json, 'garageSpotId') ? undefined : json['garageSpotId'],
    };
}
export function MoveCarDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'oldGarageId': value.oldGarageId,
        'newGarageId': value.newGarageId,
        'garageSpotId': value.garageSpotId,
    };
}
